import $ from 'jquery';

export default class Selectable {
  constructor(element, id) {
    this.id = id;
    this.$element = $(element);
    this.change = this.change.bind(this);
    this.$tabs = this.$element.find('div.tab');
    this.active = this.$tabs.filter('.active').attr('id');
    this.createSelection();
  }

  createSelection() {
    // Create a select element
    const $select = $(`<select id="tabs-selection-${this.id}"></select>`);
    const options = new Map();

    // Cycle though each tab
    this.$tabs.each((key, tab) => {
      // Extract the tab title
      const content = tab.textContent.replace(/([\w\d\s]+) (\(\d+\))/g, '$1');
      // Create an option element
      const $option = $(`<option value="${tab.id}">${content}</option>`);
      // Identify active select option
      if (tab.id === this.active) {
        $option.attr('selected', true);
      }
      // Add item to our array of options
      options.set(content.toLowerCase(), $option);
    });

    const alphaOptions = new Map([...options.entries()]);
    alphaOptions.forEach((value) => {
      $select.append(value);
    });

    const $form = $('<form method="get" class="tabs-by-selection"></form>');
    const label = `<label for="tabs-selection-${this.id}">Filter by:</label>`;
    const $wrap = $('<div class="select-component"></div>');
    $form.append(label, $wrap);
    $wrap.append($select);

    // Add event handler
    $select.on('change', this.change);

    // Add select list within the markup
    $form.insertBefore(this.$element);
  }

  change(event) {
    const id = $(event.currentTarget).val();
    this.$tabs.filter(`[id=${id}]`).trigger('click');
  }
}
